import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type { ModelFrom } from 'tio-employee/types/route-model';
import type TasRoute from '../tas';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type SessionContextService from 'tio-employee/services/session-context';
import type TuitionAssistanceService from 'tio-common/services/tuition-assistance';

export default class AuthenticatedCareerPathwaysTasDashboardRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare sessionContext: SessionContextService;
  @service declare tuitionAssistance: TuitionAssistanceService;

  async model() {
    const parentModel = this.modelFor('authenticated.reimagined.tas') as ModelFrom<TasRoute>;
    const currentEmployee = this.sessionContext.currentEmployee;

    // Compute enrolled template IDs from the user's applications
    const enrolledTemplateIds = new Set(
      parentModel.tasData.applications
        .filter((app) => app.programTemplateId)
        .map((app) => app.programTemplateId as string)
    );

    const [eligibleTemplates, limitsStatus] = await Promise.all([
      this.reimaginedData.fetchEligibleTemplates(enrolledTemplateIds),
      currentEmployee
        ? this.tuitionAssistance.getV2LimitsStatus(currentEmployee, undefined)
        : undefined,
    ]);

    return {
      ...parentModel,
      eligibleTemplates,
      limitsStatus,
    };
  }
}
